<template>
    <section class="bg-white container-global q-py-xl" id="solutions">
        <div class="">
            <div class="header_section">
                <span class="header_section-sub-title">
                    البساطة والفعالية
                </span>
                <h3 class="header_section-title">
                    حلول أداة أكواد
                </h3>
                <p class="header_section-description">
                    نساعدك على تصميم موقعك أو منتجك الرقمي بناءً على بيانات وتجربة استخدام حقيقية بدل التوقعات
                    والتخمينات </p>
            </div>

            <div class="comparison-section q-mx-auto row justify-center q-pt-xl q-pb-xl" id="solutions-comparison"
                ref="comparisonSectionRef">
                <!-- Feature Table -->
                <div class="comparison-table q-pt-md">
                    <ul class="w-100 text-right custom-table">
                        <li class="custom-table-row comparison-table">نـــــــــــــــــــوع التقييم</li>
                        <li class="custom-table-row comparison-table">من يقوم بالتقييم</li>
                        <li class="custom-table-row comparison-table">آلــــــــــــية التقـــــييم</li>
                        <li class="custom-table-row comparison-table">عـــــــرض النــــــتائج</li>
                        <li class="custom-table-row comparison-table">الاشتـراك والتكلفة</li>
                        <li class="custom-table-row comparison-table">الشركات والجهـات</li>
                        <li class="custom-table-row comparison-table">الهـــــــــــــــــــــــــــــــــــــــدف</li>
                    </ul>
                </div>

                <div class="comparison-cards" v-if="$q.screen.width > 776">
                    <div class="comparison-card custom-card col-3 flex flex-column items-center q-mb-md">
                        <div class="logo-plan">
                            <img src="@/assets/images/akwadrate.svg" alt="التقييع العام" height="32">
                        </div>
                        <div class="comparison-card-title text-h6 text-bold">التقييم العام</div>
                        <ul class="comparison-card-list q-mb-lg w-100">
                            <li class="custom-card-list-item">تقييم عام</li>
                            <li class="custom-card-list-item">عامة الناس</li>
                            <li class="custom-card-list-item">آراء وانطباعات</li>
                            <li class="custom-card-list-item">ملخصات عامة</li>
                            <li class="custom-card-list-item">مجانا</li>
                            <li class="custom-card-list-item">الكل</li>
                            <li class="custom-card-list-item no-border">تحسين السمعة الرقمية</li>
                        </ul>
                        <button tabindex="0"  role="button"  class="primary_btn_outline w-100 q-mt-md custom-outline-btn"
                            @click="router.push({ name: 'HomePage' })">جرب الآن</button>
                    </div>
                    <div class="comparison-card custom-card col-3 flex flex-column items-center q-mb-md">
                        <div class="logo-plan">
                            <img src="@/assets/images/akwadexpert.svg" alt="الاكسبرت" height="32">
                        </div>
                        <div class="comparison-card-title text-h6 text-bold q-mb-md q-mt-lg">تقييم الخبير</div>
                        <ul class="comparison-card-list q-mb-lg w-100">
                            <li class="custom-card-list-item">تقييم احترافي</li>
                            <li class="custom-card-list-item">خبراء متخصصين</li>
                            <li class="custom-card-list-item">تقييم تفصيلي</li>
                            <li class="custom-card-list-item">تقارير احترافية</li>
                            <li class="custom-card-list-item">السعر حسب الطلب</li>
                            <li class="custom-card-list-item">صغيرة ومتوسطة</li>
                            <li class="custom-card-list-item no-border"> توصيات لتطوير منتجك الرقمي</li>
                        </ul>
                        <button tabindex="0"  role="button"  class="primary_btn w-100 q-mt-md custom-main-btn"
                            @click="router.push({ name: 'SubscriptionPage' })">اطلب تقربر خبير</button>
                    </div>
                    <div
                        class="comparison-card custom-card col-3 flex flex-column items-center q-mb-md custom-card-lab position-relative">
                        <div class="custom-badge-wrapper flex flex-center">
                            <span class="custom-badge">الحل الأفضل</span>
                        </div>
                        <div class="logo-plan">
                            <img src="@/assets/images/akwadlab.svg" alt="مختبر اكواد" height="32">
                        </div>
                        <div class="comparison-card-title text-h6 text-bold q-mb-md q-mt-xl">مختبر أكواد</div>
                        <ul class="comparison-card-list q-mb-lg w-100">
                            <li class="custom-card-list-item">اختبارات تفاعلية</li>
                            <li class="custom-card-list-item">جمهورك المستهدف</li>
                            <li class="custom-card-list-item">تحليل سلوك وملاحظات المستخدم</li>
                            <li class="custom-card-list-item">تقارير احترافية</li>
                            <li class="custom-card-list-item">اشتراك شهري</li>
                            <li class="custom-card-list-item">المتوسطة والكبيرة</li>
                            <li class="custom-card-list-item no-border"> تحليل تفصيلي ورصد للمشاكل وحلها</li>
                        </ul>
                        <button tabindex="0"  role="button"  class="primary_btn_outline w-100 q-mt-md custom-outline-btn"
                            @click="router.push({ name: 'LabPage' })">انتقل للمختبر</button>
                    </div>
                </div>

                <template v-else>


                    <swiper :loop="true" :spaceBetween="30" :pagination="{
                        clickable: true,
                    }" :autoplay="{
                        delay: 2000,
                        disableOnInteraction: false,
                    }" :modules="[Autoplay, Pagination]" 
                    @slideChangeTransitionEnd="onSlideChange"
                    @autoplay="onAutoplay"

                    
                    class="comparison-cards">
                        >
                        <SwiperSlide>
                            <div class="comparison-card custom-card col-3 flex flex-column items-center q-mb-xl">
                                <div class="logo-plan">
                                    <img src="@/assets/images/akwadrate.svg" alt="التقييع العام" height="32">
                                </div>
                                <div class="comparison-card-title text-h6 text-bold">التقييم العام</div>
                                <ul class="comparison-card-list q-mb-lg w-100">
                                    <li class="custom-card-list-item">تقييم عام</li>
                                    <li class="custom-card-list-item">عامة الناس</li>
                                    <li class="custom-card-list-item">آراء وانطباعات</li>
                                    <li class="custom-card-list-item">ملخصات عامة</li>
                                    <li class="custom-card-list-item">مجانا</li>
                                    <li class="custom-card-list-item">الكل</li>
                                    <li class="custom-card-list-item no-border">تحسين السمعة الرقمية</li>
                                </ul>
                                <button tabindex="0"  role="button"  class="primary_btn_outline w-100 q-mt-md custom-outline-btn"
                                    @click="router.push({ name: 'HomePage' })">جرب الآن</button>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div class="comparison-card custom-card col-3 flex flex-column items-center q-mb-xl">
                                <div class="logo-plan">
                                    <img src="@/assets/images/akwadexpert.svg" alt="الاكسبرت" height="32">
                                </div>
                                <div class="comparison-card-title text-h6 text-bold q-mb-md q-mt-lg">تقييم الخبير</div>
                                <ul class="comparison-card-list q-mb-lg w-100">
                                    <li class="custom-card-list-item">تقييم احترافي</li>
                                    <li class="custom-card-list-item">خبراء متخصصين</li>
                                    <li class="custom-card-list-item">تقييم تفصيلي</li>
                                    <li class="custom-card-list-item">تقارير احترافية</li>
                                    <li class="custom-card-list-item">السعر حسب الطلب</li>
                                    <li class="custom-card-list-item">صغيرة ومتوسطة</li>
                                    <li class="custom-card-list-item no-border"> توصيات لتطوير منتجك الرقمي</li>
                                </ul>
                                <button tabindex="0"  role="button"  class="primary_btn w-100 q-mt-md custom-main-btn"
                                    @click="router.push({ name: 'SubscriptionPage' })">اطلب رأي خبير</button>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div
                                class="comparison-card custom-card col-3 flex flex-column items-center q-mb-x custom-card-lab position-relative">
                                <div class="custom-badge-wrapper flex flex-center">
                                    <span class="custom-badge">الحل الأفضل</span>
                                </div>
                                <div class="logo-plan">
                                    <img src="@/assets/images/akwadlab.svg" alt="مختبر اكواد" height="32">
                                </div>
                                <div class="comparison-card-title text-h6 text-bold q-mb-md q-mt-xl">مختبر أكواد</div>
                                <ul class="comparison-card-list q-mb-lg w-100">
                                    <li class="custom-card-list-item">اختبارات تفاعلية</li>
                                    <li class="custom-card-list-item">جمهورك المستهدف</li>
                                    <li class="custom-card-list-item">تحليل سلوك وملاحظات المستخدم</li>
                                    <li class="custom-card-list-item">تقارير احترافية</li>
                                    <li class="custom-card-list-item">اشتراك شهري</li>
                                    <li class="custom-card-list-item">المتوسطة والكبيرة</li>
                                    <li class="custom-card-list-item no-border"> تحليل تفصيلي ورصد للمشاكل وحلها</li>
                                </ul>
                                <button tabindex="0"  role="button"  class="primary_btn_outline w-100 q-mt-md custom-outline-btn"
                                    @click="router.push({ name: 'LabPage' })">انتقل للمختبر</button>
                            </div>
                        </SwiperSlide>

                    </swiper>
                </template>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import 'swiper/css';
import { useQuasar } from 'quasar';
import { Swiper, SwiperSlide } from 'swiper/vue';
import type { Swiper as SwiperClass , AutoplayOptions } from 'swiper/types';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/scrollbar';

import { Pagination, Autoplay } from 'swiper/modules';

let lastInteractionTime = 0;
let lastChangeByAutoplay = ref(false);
function onAutoplay(swiper: SwiperClass) {
  // autoplay triggered this change
  lastChangeByAutoplay.value = true;
  (swiper.params.autoplay as AutoplayOptions).delay = 2000; // ✅ cast
  swiper.autoplay.start();
}

function onSlideChange(swiper: SwiperClass) {
  if (!lastChangeByAutoplay.value) {
    // user interaction (swipe or pagination click)
    (swiper.params.autoplay as AutoplayOptions).delay = 10000; // ✅ cast
    swiper.autoplay.start();
  }
  lastChangeByAutoplay.value = false; // reset flag
}

const $q = useQuasar();
const router = useRouter();
const comparisonSectionRef = ref<HTMLElement | null>(null);

</script>

<style scoped lang="scss">
.custom-card {
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(88, 84, 255, 0.04);
    border: 1px solid #EFEFF2;
    border-radius: 20px;
    padding: 32px 24px 24px 24px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 320px;

    @media (max-width:776px) {
        min-width: 240px;

    }

    @media (max-width:500px) {
        min-width: 230px;

    }
}

.custom-card-list-item {
    padding: 12px 24px 12px 0;
    border-bottom: 1px solid #F1F1F4;
    font-size: 16px;
    color: #222;

    @media (max-width:776px) {
        padding: 12px 0px 12px 0px !important;
        font-size: 14px;

    }
}

.custom-card-list-item.no-border {
    border-bottom: none;
}

.custom-outline-btn {
    font-weight: 500;
    width: 80%;
    margin-top: 30px
}

.custom-main-btn {
    font-weight: 500;
    width: 80%;
    margin-top: 30px
}

.custom-card-lab {
    position: relative;
}

.custom-badge-wrapper {
    width: fit-content;
    position: absolute;
    top: 16px;
    left: 16px;
    justify-content: center;
}

.custom-badge {
    background: #F6F5FF;
    color: #5854ff;
    font-size: 15px;
    font-weight: bold;
    border-radius: 16px;
    padding: 4px 18px;
    display: inline-block;
}

.custom-table {
    width: 100%;
}

.custom-table-row {
    padding: 12px 0 12px 0;
    color: #6f6f6f;
    border-bottom: 1px solid #F1F1F4;
    font-size: 16px;
    text-align: center;
    font-weight: 700;

    @media (max-width: 776px) {
        font-size: 14px;

    }
}

.custom-table-row.no-border {
    border-bottom: none;
}

.comparison-section {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 16px;
    overflow-x: auto;
    scroll-behavior: smooth;
    // This makes the scrollbar start at the right in RTL
    scrollbar-width: thin;
    flex-wrap: nowrap;

    @media (min-width: 1200px) {
        justify-content: space-between;
    }

    @media (max-width: 600px) {
        gap: 8px;
    }

    .comparison-table {
        min-width: 260px;
        flex: 1;

        @media (max-width: 600px) {
            min-width: 120px;
        }

     
    }

    .comparison-cards {
        display: flex;
        align-items: center;
        gap: 16px;
    }
}

.custom-table {
    margin-top: 65px;
}

.comparison-card-title {
    text-align: start;
    width: 100%;
    margin-block: 28px;
}

.comparison-card-list {
    width: 100%;

    @media (max-width:776px) {
        margin-bottom: -32px;
    }
}

ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
        text-align: start;
    }
}

.logo-plan {
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>

<style>
.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
    display: flex;
    width: 100%;
    height: 6px;
    position: absolute;
    z-index: 999999999999999;
    left: 20px;
    bottom: 0px;
    border-radius: 16px;
    align-items: center;
    justify-content: start;

}

.swiper-pagination-bullet {
    cursor: pointer;
    display: block;
    width: 25%;
    background: #ebebeb;
    height: 100%;
    border-radius: 16px;
    margin-left: 3%;

}

.swiper-pagination-bullet.swiper-pagination-bullet-active {

    background: #5854ff;


}
</style>